import { DrawerTitle } from "@growtherapy/sprout-ui";

export function Header() {
  return <DrawerTitle>How are you feeling today?</DrawerTitle>;
}
